import { api } from "app/helpers/apiHelperV3";
import { urls } from "./urls";

const API_EVENTS_COMPETITIONS = urls.data.API_EVENTS_COMPETITIONS();

/**
 * search event competitions list
 */
export const getSearchList = (name: any): any => {
  const url = API_EVENTS_COMPETITIONS;
  const data = {
    params: {
      name: name,
    },
  };
  return api
    .get(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
